import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { Credenciales, UsuarioSesion } from '@serkat/shared'
import { ErrorApi, api } from '../../api/cliente'

const CLAVE = ['sesion'] as const

export function useSesion() {
  const { data, isPending } = useQuery({
    queryKey: CLAVE,
    queryFn: async (): Promise<UsuarioSesion | null> => {
      try {
        return await api.get<UsuarioSesion>('/auth/yo')
      } catch (e) {
        if (e instanceof ErrorApi && e.status === 401) return null
        throw e
      }
    },
    retry: false,
    staleTime: 60_000,
  })

  return { usuario: data ?? null, cargando: isPending }
}

export function useIniciarSesion() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (cred: Credenciales) => api.post('/auth/login', cred),
    onSuccess: () => qc.invalidateQueries({ queryKey: CLAVE }),
  })
}

export function useCerrarSesion() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post('/auth/logout', {}),
    onSuccess: () => {
      // Misma razón que en el cambio de contraseña: la sesión ya no existe del
      // lado del servidor, y una recarga es la forma más segura de no dejar
      // datos de la sesión anterior en memoria.
      qc.clear()
      window.location.replace('/')
    },
  })
}
